import React, { useEffect, useState } from 'react';
import { onAuthStateChanged  } from "firebase/auth";
import { auth, isLoggedIn, CheckLoggedIn, loadFacebookSDK, handleFacebookRedirectResult } from './firebase/firebase-handler';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { WelcomePage } from './pages/WelcomePage';
import { EmailSignUp } from './pages/EmailSignUp';
import { EmailLogin } from './pages/EmailLogin';
import { ForgotPassword } from './pages/ForgotPassword';
import { PolicyDisplayPg } from './pages/util/Util_PolicyDisplay';
import { GuestSignUp } from './pages/GuestSignUp';
import { AuthHandlerLogger } from './pages/AuthHandlerLogger';
import { LoadingPage } from './pages/LoadingPage';
import GamePage from './pages/GamePage';
import TestConnection from './pages/util/Util_TestConnection';
import { isGuest, SignInAsGuest } from './util/guestDataHandler';

// A linkCode in the URL means the HostApp title-screen "Sign in to Continue" flow sent this
// visitor here specifically to link a REAL account (see pt-update-user-data's /link/create) -
// a cached guest session must not satisfy that, or a guest could "link" a non-account.
const hasLinkCode = () => !!new URLSearchParams(window.location.search).get('linkCode');

function App({ }) {
    const [isAuthenticated, setAuthenticated] = useState(null);
    console.log('Loading App');

    const CancelLoading = () => {
        console.log("canceled loading");
    };

    useEffect(() => {
        console.log("[CheckFBLogin] App starting...");
        let unsubscribe = () => {};
        const init = async () => {
            // Then check login status
            const loggedIn = await CheckLoggedIn();
            setAuthenticated(loggedIn || (isGuest() && !hasLinkCode()));
            unsubscribe = onAuthStateChanged(auth, (user) => {
                setAuthenticated(!!user);
            });

            // Setup FB SDK
            loadFacebookSDK().catch(err =>
                console.error("[FB SDK load failed]", err)
            );

            // Check for FB login
            handleFacebookRedirectResult((success) => {
                console.log("[CheckFBLogin] Succesfully got redirect result:", success);
            },(error) => {
                console.error("[CheckFBLogin] Redirect result error:", error);
            });            
        };

        init();
        return () => unsubscribe(); 
    }, []);

    const authenticatedRoutes = [
        { path: "/", element: <GamePage /> },
    ];

    const unauthenticatedRoutes = [
        { path: "/", element: <WelcomePage /> },
        { path: "/login", element: <EmailLogin /> },
        { path: "/signup", element: <EmailSignUp /> },
        { path: "/resetpassword", element: <ForgotPassword /> },
        { path: "/guestlogin", element: <GuestSignUp signInAsGuest={SignInAsGuest} /> },
    ];

    const commonRoutes = [
        { path: "/tos", element: <PolicyDisplayPg filePath='/text/tos.html'/> },
        { path: "/privacypolicy", element: <PolicyDisplayPg filePath='/text/privacy-policy.html'/> },
        { path: "/faq", element: <PolicyDisplayPg filePath='/text/faq.html'/> },
        //{ path: "/testing", element: <TestConnection /> },
        { path: "*", element: <Navigate to="/" /> },
    ];

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/__/auth/handler" element={<AuthHandlerLogger />} />
                
                {isAuthenticated === null ? (
                    // Render nothing (or a loading placeholder) while checking auth
                    <Route path="*" element={<LoadingPage loadingText="Loading... 0%" OnCancel={CancelLoading} />} />
                ) : (
                    (isAuthenticated || (isGuest() && !hasLinkCode()) ? authenticatedRoutes : unauthenticatedRoutes).map(route => (
                        <Route key={route.path} path={route.path} element={route.element} />
                    ))
                )}

                {commonRoutes.map(route => (<Route key={route.path} path={route.path} element={route.element}/>))}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
